import React from "react";
import { array, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import StaticFooterLinks from "../../../molecules/StaticFooterLinks";
import SocialIcons from "../../../molecules/SocialIcons";

import "./defaultFooter.m.css";

const DefaultFooterBase = ({ socialLinks, staticFooterLinks, publisherSettings }) => {
  return (
    <div className="footer">
      <div styleName="row2">
        <div styleName="social-icons">
          <SocialIcons socialLinks={socialLinks || {}} />
        </div>
      </div>
      <div styleName="row3">
        <div styleName="static-links">
          {staticFooterLinks && staticFooterLinks.length ? <StaticFooterLinks links={staticFooterLinks} /> : null}
        </div>
        <div styleName="copyright">{publisherSettings.copyright || ""}</div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  staticFooterLinks: get(state, ["qt", "data", "navigationMenu", "staticFooterLinks"], []),
  publisherSettings: get(state, ["qt", "config", "publisher-settings"], {})
});

DefaultFooterBase.propTypes = {
  socialLinks: object,
  staticFooterLinks: array,
  publisherSettings: object
};

export const DefaultFooter = connect(mapStateToProps)(DefaultFooterBase);
